/**
 * Enum obsahující hodnoty pro identifikaci událostí stisknutí kláves. Hodnoty odpovídají "key" z KeyboardEvent,
 * které odpovídají https://www.w3.org/TR/uievents-key/#named-key-attribute-values.
 */
export enum SharedKey {
    Enter = "Enter",
    Escape = "Escape",
    ArrowLeft = "ArrowLeft",
    ArrowUp = "ArrowUp",
    ArrowDown = "ArrowDown",
    ArrowRight = "ArrowRight",
    Tab = "Tab",
    Backspace = "Backspace",
    Delete = "Delete",
    Pause = "Pause",
    CapsLock = "CapsLock",
    Home = "Home",
    End = "End",
    PrintScreen = "PrintScreen",
    ContextMenu = "ContextMenu",
    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
    F5 = "F5",
    F6 = "F6",
    F7 = "F7",
    F8 = "F8",
    F9 = "F9",
    F10 = "F10",
    F11 = "F11",
    F12 = "F12",
    NumLock = "NumLock",
    ScrollLock = "ScrollLock",
    PageDown = "PageDown",
    PageUp = "PageUp",
}

export enum OnlyKey {
    Space = " ",
    Windows = "Meta",
    Ctrl = "Control",
    Alt = "Alt",
    AltGr = "AltGraph",
}

/**
 * Enum obsahujici hodnoty pro identifikaci udalsti stisknutí kláves. Hodnoty odpovídají "code" z KeyboardEvent,
 * viz. https://www.w3.org/TR/uievents-code
 *
 * Rozdíl mezi Key a Code je v základu v tom, ze pozice klávesy odpovída původnímu bez ohledu na nastavení jazyka
 * tedy například 'Z', které se nacházi, na české klávesníci, nahoře uprostřed, je vráceno jako 'KeyY'.
 * Navíce je konstatní při zapnutem CapsLock, v key je 'v' při zapnutem CapsLock 'V' tady prostě 'KeyV'
 */
enum OnlyCode {
    Space = "Space",
    LeftAlt = "AltLeft",
    RightAlt = "AltRight",
    LeftCtrl = "ControlLeft",
    RightCtrl = "ControlRight",
    LeftShift = "ShiftLeft",
    RightShift = "ShiftRight",
    LeftWindows = "MetaLeft",
    RightWindows = "MetaRight",
    KeyA = "KeyA",
}

/**
 * Enum obsahující hodnoty pro identifikaci událostí stisknutí kláves. Hodnoty odpovídají "key" z KeyboardEvent,
 * které odpovídají https://www.w3.org/TR/uievents-key/#named-key-attribute-values.
 */
export const Key = { ...SharedKey, ...OnlyKey };
export type Key = typeof Key;

/**
 * Enum obsahujici hodnoty pro identifikaci udalsti stisknutí kláves. Hodnoty odpovídají "code" z KeyboardEvent,
 * viz. https://www.w3.org/TR/uievents-code
 *
 * Rozdíl mezi Key a Code je v základu v tom, ze pozice klávesy odpovída původnímu bez ohledu na nastavení jazyka
 * tedy například 'Z', které se nacházi, na české klávesníci, nahoře uprostřed, je vráceno jako 'KeyY'.
 * Navíce je konstatní při zapnutem CapsLock, v key je 'v' při zapnutem CapsLock 'V' tady prostě 'KeyV'
 */
export const Code = { ...SharedKey, ...OnlyCode };
export type Code = typeof Code;
